import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../../styles/js/mixins';
import {colours, fonts, spacing} from '../../../styles/js/variables';

const styles = {
  calculator: css`
    label: calculator;
    display: flex;
    flex-direction: column-reverse;
    position: relative;
    z-index: 2;
    min-height: 35rem;
    padding: ${spacing.XS};
    background: ${colours.general.WHITE};
    border-radius: 1.4rem;
    box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.04);

    ${mq(Breakpoints.TABLET)} {
      padding: ${spacing.M};
      flex-direction: row;
    }
  `,
  left: css`
    label: calculator__container;
    flex: 1 1 70%;

    ${mq(Breakpoints.TABLET)} {
      padding-right: ${spacing.XL};
    }
  `,
  right: css`
    label: calculator__container;
    flex: 1 1 30%;

    ${mq(Breakpoints.TABLET)} {
      padding-left: ${spacing.M};
      border-left: 4px solid ${colours.brand.PRIMARY};
    }
  `,
  info: css`
    label: calculator__info;
    color: ${colours.semantic.PLACEHOLDER_ACTIVE};
    font-size: ${fonts.size.S};
  `,

  perMonth: css`
    label: calculator__perMonth;
    font-weight: ${fonts.weight.SEMI_BOLD};
    font-size: ${fonts.size.XXL};
  `,
};

export default styles;
